import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/utils/storage/storage.service';
import { environment } from 'src/environments/environment';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  isCollapsed = false;
  panelOpenState = false;
  appName = environment.config.appName;
  appDescription = environment.config.appDescription;
  activeOption = '';

  constructor(public permissionsService: PermissionsService, private router: Router, private storageService: StorageService) {
    this.activeOption = router.url;
    this.onResize();
  }

  setActive(value: string) {
    this.activeOption = value;
  }

  logout() {
    this.storageService.clear();
    window.location.href = environment.interop.authCore.linkRedirectAuth;
  }

  redirectToinDeskPlatform() {
    window.location.href = environment.interop.authCore.linkRedirectAuth;
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isCollapsed = window.innerWidth < 960;
  }
}
